export default "__VITE_ASSET__CLBsR_cG__"